<div class="grid__container">
  <ng-container *ngFor="let product of (products$ | async)">
    <clearcals-product-card [product]="product"></clearcals-product-card>
  </ng-container>
</div>